// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3nH5j","paramInput":"JobSimulator_paramInput__mB-KS","input":"JobSimulator_input__2tsa2"};